import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { Button } from "../Button";
import { CardAlert } from "../CardAlert";
import { Subtitle } from "../Subtitle";
import "./styles.scss";
import StoreIcon from "../../images/store.svg";
import CurrencyDollarIcon from "../../images/currency-dollar-circle.svg";
import MailIcon from "../../images/mail.svg";

interface Section6Props {}

function Section6({}: Section6Props) {
  const { handleNavigateToTerms } = useButtonsActions();

  return (
    <section className="section6" id="importante">
      <div>
        <Subtitle text="Ah, é importante lembrar que..." />

        <div className="containerCardAlert">
          <CardAlert title="Lojas indicadas" imgUrl={StoreIcon}>
            <p>
              Aceitaremos pedidos apenas das lojas indicadas. Nenhuma loja
              indicada tem vínculo com a Koin.
            </p>
          </CardAlert>

          <CardAlert title="Pagamento" imgUrl={CurrencyDollarIcon}>
            <p>
              Para liberar a sua compra, é preciso realizar o pagamento da 1ª
              parcela. Caso isso não ocorra, o parcelamento não será
              disponibilizado. E, se você quiser seguir com a compra mesmo sem o
              parcelamento da Koin, deverá efetuar o pagamento do boleto emitido
              pela loja.
            </p>
          </CardAlert>

          <CardAlert title="Olho no seu email" imgUrl={MailIcon}>
            <p>
              Toda a comunicação e envio de boletos são enviados para o e-mail
              cadastrado.
            </p>
          </CardAlert>
        </div>

        <div className="containerTerms">
          <Button
            id="termosCondicoesImportante"
            text="Ver termos e condições"
            variant="ghost"
            onClick={handleNavigateToTerms}
          />
        </div>
      </div>
    </section>
  );
}

export { Section6 };
